import { IconBase, IconBaseProps } from './IconBase';

export const OpenEyecon: React.FunctionComponent<IconBaseProps> = (props) => (
  <IconBase {...props} viewBox="0 0 24 18">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 10C1 10 3.5 16 10 16C17 16 19 10 19 10C19 10 17 4 10 4C3 4 1 10 1 10Z"
      fill="#808080"
    />
    <circle cx="10" cy="10" r="4.46192" fill="white" />
    <circle cx="10" cy="10" r="2.75" fill="#808080" />
  </IconBase>
);

export const ClosedEyecon: React.FunctionComponent<IconBaseProps> = (props) => (
  <IconBase {...props} viewBox="0 0 24 18">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 10C1.5 10 4 16 10.5 16C17.5 16 19.5 10 19.5 10C19.5 10 17.5 4 10.5 4C3.5 4 1.5 10 1.5 10Z"
      fill="#808080"
    />
    <circle cx="10.5" cy="10" r="4.46192" fill="white" />
    <circle cx="10.5" cy="10" r="2.75" fill="#808080" />
    <path d="M1.84375 2.71875L17.8438 18.7188" stroke="#808080" strokeWidth="2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.6562 18.133L2.65625 2.13296L4.07046 0.71875L20.0705 16.7188L18.6562 18.133Z"
      fill="white"
    />
  </IconBase>
);
